@if (dataTable.data && dataTable.data.length) {
    <section class="table-container d-flex">
        <table mat-table [dataSource]="dataTable" class="footer-table">
            @for (column of columns; let columnIndex = $index; track columnIndex) {
                <ng-container [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef class="mat-headline-6">
                        {{ column.header }}
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let row"
                        class="mat-subtitle-1 td-item"
                        [cdkCopyToClipboard]="column.cell(row) || ''"
                        (mouseenter)="$event.stopImmediatePropagation()"
                        (mouseleave)="$event.stopImmediatePropagation()"
                        aria-label="Copy link to the event to clipboard"
                        matTooltip="Copied to clipboard"
                        #tooltip="matTooltip"
                        (click)="tooltip.show()"
                    >
                        {{ column.cell(row) }}
                    </td>
                </ng-container>
            }
            @if (enableColumns) {
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            }
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </section>
}
@if (enableButton) {
    <button matButton="outlined" (click)="goToFailityInfo()" color="white" class="more-info-button my-3">
        FACILITY INFORMATION
    </button>
}
